import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import LoadableState from 'components/shared/loadable';
import PageTitle from 'components/shared/PageTitle';
import ViewCertificationModal from 'components/Certificate/ViewCertificationModal';
import { requestPathContents } from '../../actions/pathViewer';
import Header from './Header';
import PathProgress from './Progress';
import ContentsList from './ContentsList';
import Loader from './Loader';
import CertificationPathFooter from './CertificationPathFooter';

class PathViewer extends Component {
  constructor(props) {
    super(props);

    this.state = { isCertificateModalShown: false };
  }

  componentDidMount() {
    this.props.requestPathContents();
  }

  static defaultProps = {
    contents: [],
  };

  toggleCertificateModal = () => {
    this.setState(({ isCertificateModalShown }) => ({
      isCertificateModalShown: !isCertificateModalShown,
    }));
  };

  render() {
    const {
      title,
      loading,
      contents,
      certification,
      isComplete,
      pathProgressId,
      previewing,
      hasCurrentUser,
      hasHiddenContents,
    } = this.props;

    const showCertificateModalInPreview = !(
      previewing && contents.length === 0
    );

    return (
      <>
        {hasCurrentUser && previewing && (
          <div className="NotificationContainer NotificationContainer--secondary mt-0">
            {t('notices.previewing_content', { content_type: 'path' })}
          </div>
        )}
        <div className="PathViewer">
          {title && <PageTitle title={title} />}
          <Header
            showCertificateModalInPreview={showCertificateModalInPreview}
            toggleCertificateModal={this.toggleCertificateModal}
          />
          {loading && <Loader />}
          <LoadableState loading={loading} opacity={0.5} speed={500}>
            {!loading &&
              !isEmpty(contents) && [
                <PathProgress key="progress" />,
                <ContentsList key="contents" />,
              ]}
            {!loading && isEmpty(contents) && (
              <div className="ta-c">{t('paths.no_steps_yet')}</div>
            )}
          </LoadableState>
          {certification && (
            <CertificationPathFooter
              certification={certification}
              isComplete={isComplete}
              showCertificateModalInPreview={showCertificateModalInPreview}
              pathProgressId={pathProgressId}
              hasHiddenContents={hasHiddenContents}
              toggleCertificateModal={this.toggleCertificateModal}
            />
          )}
          {!hasHiddenContents && isComplete && certification && (
            <ViewCertificationModal
              shown={this.state.isCertificateModalShown}
              toggleModal={this.toggleCertificateModal}
              pathProgressId={pathProgressId}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ pathViewer }) => ({
  pathProgressId: pathViewer.pathProgressId,
  title: pathViewer.title,
  loading: pathViewer.loading,
  contents: pathViewer.contents,
  certification: pathViewer.badge,
  previewing: pathViewer.previewing,
  isComplete:
    !isEmpty(pathViewer.contents) &&
    pathViewer.contents.every(content => content.status === 'completed'),
  hasCurrentUser: !!pathViewer.metadata.currentUser,
  hasHiddenContents: pathViewer.hiddenContents,
});

const mapDispatchToProps = {
  requestPathContents,
};

export default connect(mapStateToProps, mapDispatchToProps)(PathViewer);
